import { TextField } from '@mui/material'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'

RHFTextField.propTypes = {
  sx: PropTypes.object,
  name: PropTypes.string,
  helperText: PropTypes.node,
}

export default function RHFTextField({ name, helperText, sx, ...other }) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          error={!!error}
          helperText={error ? error?.message : helperText}
          value={isNil(field.value) ? '' : String(field.value)}
          sx={{
            '.MuiFormHelperText-root': {
              mt: 0,
            },
            ...sx,
          }}
          {...other}
        />
      )}
    />
  )
}
